import React from "react";
import { Sparkles } from "lucide-react";
import { useI18n } from "../contexts/I18nContext";

const dash = "—";

// "Your chart at a glance" — Lagna / Sun / Moon / Nakshatra / current Dasha.
export const ChartSummaryCard = ({ summary, name, variant = "sidebar" }) => {
  const { t } = useI18n();
  if (!summary) return null;

  const items = [
    { key: "lagna", label: t("glance.lagna"), value: summary.lagna },
    { key: "sun", label: t("glance.sun"), value: summary.sun_sign },
    { key: "moon", label: t("glance.moon"), value: summary.moon_sign },
    { key: "nakshatra", label: t("glance.nakshatra"), value: summary.nakshatra },
  ];
  const dasha = [summary.mahadasha, summary.antardasha].filter(Boolean).join(" → ");
  if (!items.some(i => i.value) && !dasha) return null;

  if (variant === "strip") {
    return (
      <div data-testid="chart-glance-strip" className="glance-strip">
        {items.filter(i => i.value).map(i => (
          <div key={i.key} data-testid={`glance-strip-${i.key}`} className="glance-pill"
            style={{ padding: "7px 12px", borderRadius: "10px", background: "rgba(255,209,102,0.07)", border: "1px solid rgba(255,209,102,0.16)" }}>
            <div style={{ color: "rgba(255,255,255,0.4)", fontSize: "0.6rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>{i.label}</div>
            <div style={{ color: "#FFD166", fontSize: "0.78rem", fontWeight: 600 }}>{i.value}</div>
          </div>
        ))}
        {dasha && (
          <div data-testid="glance-strip-dasha" className="glance-pill"
            style={{ padding: "7px 12px", borderRadius: "10px", background: "rgba(157,78,221,0.1)", border: "1px solid rgba(157,78,221,0.25)" }}>
            <div style={{ color: "rgba(255,255,255,0.4)", fontSize: "0.6rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>{t("glance.dasha")}</div>
            <div style={{ color: "#c084fc", fontSize: "0.78rem", fontWeight: 600 }}>{dasha}</div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div data-testid="chart-glance-card" className="glass-card"
      style={{ padding: "14px", marginBottom: "16px", border: "1px solid rgba(255,209,102,0.18)" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "10px" }}>
        <Sparkles size={13} style={{ color: "#FFD166" }} />
        <h3 className="font-cinzel" style={{ color: "#FFD166", fontSize: "0.82rem" }}>{t("glance.title")}</h3>
      </div>
      {name && (
        <div style={{ color: "rgba(255,255,255,0.45)", fontSize: "0.7rem", marginBottom: "10px" }}>{name}</div>
      )}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
        {items.map(i => (
          <div key={i.key} data-testid={`glance-${i.key}`} style={{ background: "rgba(255,255,255,0.03)", borderRadius: "8px", padding: "7px 8px" }}>
            <div style={{ color: "rgba(255,255,255,0.38)", fontSize: "0.6rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>{i.label}</div>
            <div style={{ color: "white", fontSize: "0.78rem", fontWeight: 600 }}>{i.value || dash}</div>
          </div>
        ))}
      </div>
      {dasha && (
        <div data-testid="glance-dasha" style={{ marginTop: "8px", background: "rgba(157,78,221,0.1)", border: "1px solid rgba(157,78,221,0.2)", borderRadius: "8px", padding: "8px" }}>
          <div style={{ color: "rgba(255,255,255,0.38)", fontSize: "0.6rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>{t("glance.dasha")}</div>
          <div style={{ color: "#c084fc", fontSize: "0.8rem", fontWeight: 600 }}>{dasha}</div>
          {summary.dasha_until && (
            <div style={{ color: "rgba(255,255,255,0.35)", fontSize: "0.65rem", marginTop: "2px" }}>
              {t("glance.until")} {summary.dasha_until}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ChartSummaryCard;
